/**
 * Composing <Route> in React Router v6
 * https://gist.github.com/mjackson/d54b40a094277b7afdd6b81f51a0393f
 *
 * Upgrading from v5
 * https://reactrouter.com/docs/en/v6/upgrading/v5
 */
import { Routes, Route, redirect, Navigate, useNavigate } from 'react-router-dom';

import { Dashboard } from 'pages/Dashboard';
import { Login } from 'pages/Login';
import { NotFound } from 'pages/NotFound';
import { PrivateRoute } from './PrivateRoute';
import { PublicRoute } from './PublicRoute';
// import { Shop } from 'pages/Shop';
import ShopDetail from 'pages/Shop/Detail';
import Reconhecer from 'pages/Reconhecer';
import Extrato from 'pages/Extrato';
import Historico from 'pages/Historico';
import Faq from 'pages/Faq';
import Regulamento from 'pages/Regulamento';
import Convidar from 'pages/Convidar';
// import { ShopTeaser } from 'pages/Shop/teaser';
import MissaoDestaque from 'pages/MissaoDestaque';
import { ApreciarRealizacao } from 'pages/MinhaEquipe/ApreciarRealizacao';
import { Catalog } from 'pages/Catalog';
import MissaoDestaqueCreate from 'pages/MissaoDestaque/Create';
import GaleriaReconhecimento from 'pages/GaleriaReconhecimento';
import DestaquesCultura from 'pages/DestaquesCultura';
import { DestaquesCulturaDetail } from 'pages/DestaquesCultura/detail';
import { Manifesto } from 'pages/Manifesto';
import MinhaEquipe from 'pages/MinhaEquipe';
import CustomNavigationClient from 'sso/azure/CustomNavigationClient';
import { MsalProvider } from '@azure/msal-react';
import Rede from 'pages/Rede';
import Destaque from 'pages/Destaque';
// import AnalisarParticipacaoGerentes from 'pages/MinhaEquipe/AnalisarParticipacaoGerentes';
import AnalisarParticipacaoEquipe from 'pages/MinhaEquipe/AnalisarParticipacaoEquipe';
import Challenges from 'pages/Challenges';
import Selos from 'pages/Selos';
import ChallengesLancamento from 'pages/ChallengesLancamento';
import { Shop } from 'pages/Shop';
import { Store } from 'pages/Store';
import PontuamMasNaoAvaliam from 'pages/MinhaEquipe/PontuamMasNaoAvaliam';
import Feed from 'pages/Feed';
import Perfil from 'pages/Perfil';

export const RouteList = ({ msalInstance }: any) => {
  const navigate = useNavigate();
  const navigationClient = new CustomNavigationClient(navigate);
  msalInstance.setNavigationClient(navigationClient);

  return (
    <MsalProvider instance={msalInstance}>
      <Routes>
        <Route
          path="/"
          element={
            <PrivateRoute redirectTo="/login">
              <Dashboard />
            </PrivateRoute>
          }
        >
          <Route
            path="/reconhecer"
            element={
              <PrivateRoute redirectTo="/login">
                <Reconhecer />
              </PrivateRoute>
            }
          />

          <Route
            path="/reconhecer/:id"
            element={
              <PrivateRoute redirectTo="/login">
                <Reconhecer />
              </PrivateRoute>
            }
          />

          <Route
            path="/convidar"
            element={
              <PrivateRoute redirectTo="/login">
                <Convidar />
              </PrivateRoute>
            }
          />
        </Route>

        {/* <Route path="/missao-destaque" element={<Navigate to="/realizacao-destaque" />} />

        <Route
          path="/realizacao-destaque"
          element={
            <PrivateRoute redirectTo="/login">
              <MissaoDestaque />
            </PrivateRoute>
          }
        >
          <Route
            path="/realizacao-destaque/:id"
            element={
              <PrivateRoute redirectTo="/login">
                <MissaoDestaqueCreate />
              </PrivateRoute>
            }
          />
        </Route> */}

        <Route path="/validar-destaque" element={<Navigate to="/minha-equipe/validar-apreciar-realizacao" />} />

        <Route
          path="/extrato"
          element={
            <PrivateRoute redirectTo="/login">
              <Extrato />
            </PrivateRoute>
          }
        />

        <Route path="/quadro-equipe" element={<Navigate to="/minha-equipe" />} />

        <Route path="/minha-equipe">
          <Route
            index
            element={
              <PrivateRoute redirectTo="/login">
                <MinhaEquipe />
              </PrivateRoute>
            }
          />

          {/* <Route
            path="validar-apreciar-realizacao"
            element={
              <PrivateRoute redirectTo="/login">
                <ApreciarRealizacao />
              </PrivateRoute>
            }
          >
            <Route
              path=":id"
              element={
                <PrivateRoute redirectTo="/login">
                  <MissaoDestaqueCreate />
                </PrivateRoute>
              }
            />
          </Route> */}

          {/* <Route
            path="participantes-da-realizacao"
            element={
              <PrivateRoute redirectTo="/login">
                <AnalisarParticipacaoEquipe />
              </PrivateRoute>
            }
          />

          <Route
            path="dupla-lideranca"
            element={
              <PrivateRoute redirectTo="/login">
                <PontuamMasNaoAvaliam />
              </PrivateRoute>
            }
          /> */}
        </Route>

        <Route
          path="/rede-dti-360"
          element={
            <PrivateRoute redirectTo="/login">
              <Rede />
            </PrivateRoute>
          }
        />

        <Route
          path="/manifesto"
          element={
            <PrivateRoute redirectTo="/login">
              <Manifesto />
            </PrivateRoute>
          }
        />

        <Route
          path="/experiencias"
          element={
            <PrivateRoute redirectTo="/login">
              <Catalog />
            </PrivateRoute>
          }
        >
          <Route path=":id" element={<ShopDetail />} />
        </Route>

        <Route
          path="/galeria"
          element={
            <PrivateRoute redirectTo="/login">
              <GaleriaReconhecimento />
            </PrivateRoute>
          }
        ></Route>

        <Route
          path="/destaques-cultura"
          element={
            <PrivateRoute redirectTo="/login">
              <DestaquesCultura />
            </PrivateRoute>
          }
        ></Route>

        <Route
          path="/destaques"
          element={
            <PrivateRoute redirectTo="/login">
              <Destaque />
            </PrivateRoute>
          }
        ></Route>

        <Route
          path="/desafios/:id"
          element={
            <PrivateRoute redirectTo="/login">
              <Challenges />
            </PrivateRoute>
          }
        ></Route>

        <Route
          path="/desafios-lancamento"
          element={
            <PrivateRoute redirectTo="/login">
              <ChallengesLancamento />
            </PrivateRoute>
          }
        ></Route>

        <Route
          path="/feed-reconhecimentos"
          element={
            <PrivateRoute redirectTo="/login">
              <Feed />
            </PrivateRoute>
          }
        ></Route>

        <Route
          path="/loja"
          element={
            <PrivateRoute redirectTo="/login">
              <Store />
            </PrivateRoute>
          }
        ></Route>

        <Route
          path="/perfil/:id"
          element={
            <PrivateRoute redirectTo="/login">
              <Perfil />
            </PrivateRoute>
          }
        />

        <Route path="/ajuda" element={<Faq />} />

        <Route path="/regulamento" element={<Regulamento />} />

        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </MsalProvider>
  );
};
